// The file "hosting" the proxy on the webstore side

const debug = require('debug')('plugin:server');
const Server = require('./lib/Server');
const domready = require('domready');

// Polyfills
require('core-js/fn/array/includes');
require('core-js/fn/object/assign');

(function (doc, win) {
	'use strict';

	domready(() => {
		debug('domready');
		new Server({window: win, clientWindow: win.top, env: {}});
	});
}(document, window));
